var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[((_vm.$store.getters.getPackage != 'premium' ) && _vm.value)?[_c('div',{staticClass:"label label-info",staticStyle:{"padding":"3px 15px","display":"inline-block"}},[_vm._v(_vm._s(_vm.$t("premium")))])]:((_vm.$store.getters.getPackage == 'premium' ) && _vm.value)?[_vm._t("default")]:[_vm._v("-")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-240a84a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/dashboard/CustomerItemValue.vue
// module id = null
// module chunks = 